import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

function Loader(props: { inline?: boolean }) {
  return (
    <Box
      sx={{
        position: props.inline ? 'relative' : 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99,
      }}
    >
      <CircularProgress
        variant="indeterminate"
        color={props.inline ? 'inherit' : 'primary'}
        size={props.inline ? '2rem' : '5rem'}
      />
    </Box>
  )
}

export default Loader
